module.exports = __webpack_public_path__ + "img/leidenschaft-macht-den-unterschied.a19e8a44.svg";